import React, { ReactNode } from 'react';
import iconLoading from '../../../images/spinner.svg';

type Props = {
  name: string;
  className?: string;
  onClick?: () => void;
  disabled: boolean;
  text: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  link?: string;
};

const Button = ({
  name,
  className,
  onClick,
  disabled,
  text,
  type = 'button',
}: Props) => {
  return (
    <div className="form-actions">
      <button
        name={name}
        type={type}
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        {name !== 'send_voucher' && (disabled ? <img src={iconLoading} className="spinner" alt={'icon loading'}/> : null)}
        {text}
      </button>
    </div>
  );
};

export default Button;
